<template>
  <common-modal
    :name="name"
    :title="title"
    :primaryAction="primaryAction"
    :disabledActions="errorMessage"
    :on-closed="clearModalData"
    height="auto"
    :width="generateWidth"
  >
    <template #modal-body>
      <validation-form @on-submit="saveForm" ref="addFamily">
        <p class="pl-5">{{ $t("student.account_information") }}</p>
        <div class="md-layout">
          <div
            class="md-layout-item md-size-100 md-small-size-100 text-sm pl-5"
            v-if="mode === 'add'"
          >
            <md-radio
              class="pr-4"
              v-for="(item, index) in typeAccount"
              :key="item.id + index"
              v-model.trim="typeAccountSelected"
              :value="item.id"
              >{{ $t(item.name) }}
            </md-radio>
          </div>
        </div>
        <md-card class="my-0" v-if="typeAccountSelected === 'newAccount'">
          <md-card-content>
            <div class="contact-info md-layout">
              <!-- USERNAME -->
              <div
                class="md-layout-item md-size-33 md-small-size-100"
                :class="styleErrorServer('username')"
              >
                <validation-field
                  :validations="validateContact.username"
                  :field-class="getValidationClass('username')"
                  name="username"
                >
                  <label>{{ $t("common.username") }}</label>
                  <md-input
                    required
                    v-model.trim="contact.username"
                    :disabled="isEditPage"
                  ></md-input>
                  <span class="md-error" v-if="serverValidations.username">{{
                    serverValidations.username
                  }}</span>
                </validation-field>
              </div>
              <!-- USERNAME -->

              <!-- PASSWORD -->
              <div
                v-if="!isEditPage"
                class="md-layout-item md-size-33 md-small-size-100"
                :class="styleErrorServer('password')"
              >
                <validation-field
                  :validations="validateContact.password"
                  :field-class="getValidationClass('password')"
                  name="password"
                >
                  <label>{{ $t("common.password") }}</label>
                  <md-input
                    required
                    type="password"
                    v-model.trim="contact.password"
                  ></md-input>
                  <span class="md-error" v-if="serverValidations.password">{{
                    serverValidations.password
                  }}</span>
                </validation-field>
              </div>
              <!-- PASSWORD -->

              <!-- SEX -->
              <div class="md-layout-item md-size-33 md-small-size-100">
                <md-field class="relative">
                  <label>{{ $t("common.sex") }}</label>
                  <md-select name="sex" v-model.trim="contact.sex">
                    <md-option value="Male">{{ $t("student.male") }}</md-option>
                    <md-option value="Female">{{
                      $t("student.female")
                    }}</md-option>
                    <md-option value="Other">{{
                      $t("common.other")
                    }}</md-option>
                  </md-select>
                </md-field>
              </div>
              <!-- SEX -->

              <!-- First name -->
              <div
                class="md-layout-item md-size-33 md-small-size-100"
                :class="styleErrorServer('first_name')"
              >
                <validation-field
                  :validations="validateContact.first_name"
                  :field-class="getValidationClass('first_name')"
                  name="first name"
                >
                  <label>{{ $t("common.first_name") }}</label>
                  <md-input
                    required
                    v-model.trim="contact.first_name"
                  ></md-input>
                  <span class="md-error" v-if="serverValidations.first_name">{{
                    serverValidations.first_name
                  }}</span>
                </validation-field>
              </div>
              <!-- First name -->

              <!-- Middle name -->
              <div class="md-layout-item md-size-33 md-small-size-100">
                <md-field>
                  <label>{{ $t("common.middle_name") }}</label>
                  <md-input v-model.trim="contact.middle_name"></md-input>
                </md-field>
              </div>
              <!-- Middle name -->

              <!-- Last name -->
              <div
                class="md-layout-item md-size-33 md-small-size-100"
                :class="styleErrorServer('last_name')"
              >
                <validation-field
                  :validations="validateContact.last_name"
                  :field-class="getValidationClass('last_name')"
                  name="last name"
                >
                  <label>{{ $t("common.last_name") }}</label>
                  <md-input
                    required
                    v-model.trim="contact.last_name"
                  ></md-input>
                  <span class="md-error" v-if="serverValidations.last_name">{{
                    serverValidations.last_name
                  }}</span>
                </validation-field>
              </div>
              <!-- Last name -->

              <!-- STATUS -->
              <div class="md-layout-item md-size-33 md-small-size-100">
                <md-field>
                  <label>{{ $t("common.status") }}</label>
                  <md-select name="status" v-model.trim="contact.status">
                    <md-option value="Active">{{
                      $t("common.active")
                    }}</md-option>
                    <md-option value="Inactive">{{
                      $t("common.inactive")
                    }}</md-option>
                  </md-select>
                </md-field>
              </div>
              <!-- STATUS -->

              <!-- EMAIL -->
              <div
                class="md-layout-item md-size-33 md-small-size-100"
                :class="styleErrorServer('email')"
              >
                <validation-field
                  :validations="validateContact.email"
                  :field-class="getValidationClass('email')"
                  name="email"
                >
                  <label>{{ $t("common.email") }}</label>
                  <md-input required v-model.trim="contact.email"></md-input>
                  <span class="md-error" v-if="serverValidations.email">{{
                    serverValidations.email
                  }}</span>
                </validation-field>
              </div>
              <!-- EMAIL -->

              <!-- PHONE_NUMBER -->
              <div class="md-layout-item md-size-33 md-small-size-100">
                <md-field>
                  <label>{{ $t("common.phone_number") }}</label>
                  <md-input v-model.trim="contact.phone_number"></md-input>
                </md-field>
              </div>
              <!-- PHONE_NUMBER -->

              <!-- RELATIONSHIP -->
              <div class="md-layout-item md-size-33 md-small-size-100">
                <md-field>
                  <label>{{ $t("student.relationship") }}</label>
                  <md-input v-model.trim="contact.relationship"></md-input>
                </md-field>
              </div>
              <!-- RELATIONSHIP -->
            </div>
          </md-card-content>
          <md-card-content>
            <p class="pl-4">{{ $t("student.account_address") }}</p>
            <div class="contact-info md-layout">
              <div
                class="md-layout-item md-size-100 md-small-size-100 pl-3 md-layout"
              >
                <md-radio
                  class="pr-4"
                  v-for="(item, index) in typeAddress"
                  :key="item + index"
                  v-model.trim="contact.type_account_address"
                  :value="item.id"
                  @change="changeAddressOption(item.id)"
                  >{{ $t(item.name) }}
                </md-radio>
              </div>
              <!--              -->
              <div class="md-layout-item md-size-33 md-small-size-100">
                <md-field>
                  <label>{{ $t("student.street") }}</label>
                  <md-input
                    :disabled="isDisableChangeAddress"
                    v-model.trim="contact.form_account_address.street"
                  ></md-input>
                </md-field>
              </div>
              <div class="md-layout-item md-size-33 md-small-size-100">
                <md-field>
                  <label>{{ $t("student.apartment") }}</label>
                  <md-input
                    :disabled="isDisableChangeAddress"
                    v-model.trim="contact.form_account_address.apartment"
                  ></md-input>
                </md-field>
              </div>
              <div class="md-layout-item md-size-33 md-small-size-100">
                <md-field>
                  <label>{{ $t("student.city") }}</label>
                  <md-input
                    :disabled="isDisableChangeAddress"
                    v-model.trim="contact.form_account_address.city"
                  ></md-input>
                </md-field>
              </div>
              <div class="md-layout-item md-size-33 md-small-size-100">
                <md-field v-if="isDisableChangeAddress">
                  <label>{{ $t("student.country") }}</label>
                  <md-input
                    :disabled="isDisableChangeAddress"
                    v-model.trim="contact.form_account_address.country"
                  ></md-input>
                </md-field>
                <isis-autocomplete
                  v-else
                  :label="$t('common.country')"
                  v-model="otherAddress.country.displayValue"
                  :value.sync="otherAddress.country.value"
                  :options="countryOptions"
                  :refetchOptions="
                    queryObj =>
                      getCountries(
                        otherAddress.country.value,
                        queryObj.search_key
                      )
                  "
                  :searchKey="otherAddress.country.searchKey"
                  :fields="otherAddress.country.fields"
                  fetchOnOpen
                >
                </isis-autocomplete>
              </div>
              <div class="md-layout-item md-size-33 md-small-size-100">
                <md-field v-if="isDisableChangeAddress">
                  <label>{{ $t("student.state") }}</label>
                  <md-input
                    :disabled="isDisableChangeAddress"
                    v-model.trim="contact.form_account_address.state"
                  ></md-input>
                </md-field>
                <isis-autocomplete
                  v-else
                  :label="$t('student.state')"
                  v-model="otherAddress.state.displayValue"
                  :value.sync="otherAddress.state.value"
                  :options="stateOptions"
                  :refetchOptions="
                    queryObj =>
                      getStates(otherAddress.country.value, queryObj.search_key)
                  "
                  :searchKey="otherAddress.state.searchKey"
                  :fields="otherAddress.state.fields"
                  :isDisabled="!otherAddress.country.value"
                  fetchOnOpen
                >
                </isis-autocomplete>
              </div>
              <div class="md-layout-item md-size-33 md-small-size-100">
                <md-field>
                  <label>{{ $t("student.zip") }}</label>
                  <md-input
                    :disabled="isDisableChangeAddress"
                    v-model.trim="contact.form_account_address.zip"
                  ></md-input>
                </md-field>
              </div>
            </div>
          </md-card-content>
        </md-card>
        <md-card class="my-0" v-else>
          <md-card-content>
            <div class="md-layout">
              <p class="md-layout-item md-size-100 pl-0 pb-3">
                {{ $t("student.select_family_account") }}
              </p>

              <div class="md-layout-item md-size-50 md-small-size-100 pl-0">
                <md-field>
                  <label :for="roleSelect.name">{{ roleSelect.label }}</label>
                  <md-select
                    :name="roleSelect.name"
                    :id="roleSelect.name"
                    v-model="sameContact.roleId"
                  >
                    <md-option
                      v-for="option in roleSelect.options"
                      :value="option.id"
                      :key="option.id + option.name"
                      >{{ option.name }}
                    </md-option>
                  </md-select>
                </md-field>
              </div>
              <div
                class="md-layout-item md-size-50 md-small-size-100 pl-0"
                v-if="sameContact.roleId === 'Student'"
              >
                <isis-autocomplete
                  v-model="sameContact.studentName"
                  :value.sync="sameContact.studentId"
                  :options="studentSelect.options"
                  :label="studentSelect.label"
                  :fields="studentSelect.fields"
                  :refetchOptions="studentSelect.refetchOptions"
                  :search-key="studentSelect.searchKey"
                >
                </isis-autocomplete>
              </div>
              <div
                class="md-layout-item md-size-50 md-small-size-100 pl-0"
                v-else
              >
                <family-select-component
                  :familyData="familiesSelect.options"
                  @filtering="fetchAccountFamilyConditionFamily"
                  @update-selected="sameContact.familyId = $event"
                ></family-select-component>
                <span class="text-[#ff1744]" v-if="errorMessage">
                  {{ $t("student.limited_account_select") }}
                </span>
              </div>
            </div>
            <div class="md-layout" v-if="sameContact.studentId">
              <p class="md-layout-item md-size-100 pl-0">
                {{ $t("student.dupicate_family_account") }}
              </p>
              <div
                class="md-layout-item md-size-100 flex pl-0"
                v-if="sameContact.accountFamily.length"
              >
                <md-checkbox
                  v-for="(item, index) in sameContact.accountFamily"
                  :key="item.id + index"
                  v-model="sameContact.accountFamilySelected.family_ids"
                  :value="item.id"
                  >{{ item.text }}
                </md-checkbox>
              </div>
              <p class="md-layout-item  md-size-100 pl-0" v-else>
                {{ $t("student.no_account_family") }}
              </p>
            </div>
          </md-card-content>
        </md-card>
      </validation-form>
    </template>
  </common-modal>
</template>

<script>
import CommonModal from "@/components/Base/CommonModal";
import { service_paths, service_names } from "@/constants/Services";
import { getId, Message, genErrMsgOj } from "@/helpers/utils";
import { validations } from "@/validations/students";
import FamilySelectComponent from "./FamilySelectComponent";
import cloneDeep from "lodash/cloneDeep";
import { mapGetters } from "vuex";
import { hasValidRole } from "@/helpers/role-helper";
import Role from "../../../../constants/Role";

const defaultContact = () => ({
  username: null,
  password: null,
  sex: null,
  first_name: null,
  middle_name: null,
  last_name: null,
  status: "Active",
  email: null,
  phone_number: null,
  relationship: null,
  type_account_address: "primary_address",
  form_account_address: {},
  children_id: null
});
const defaultSameContact = () => ({
  roleId: "Student",
  studentId: null,
  studentName: "",
  familyId: null,
  accountFamily: [],
  accountFamilySelected: {
    family_ids: []
  }
});
const formFamilyAddressDefault = {
  street: null,
  apartment: null,
  state: null,
  city: null,
  zip: null,
  country: null
};
const typeAddress = () => [
  { name: "student.same_to_child_primary_address", id: "primary_address" },
  { name: "student.same_to_child_secondary_address", id: "secondary_address" },
  { name: "common.other", id: "other" }
];

const typeAccount = () => [
  { name: "student.add_new_account_family", id: "newAccount" },
  { name: "student.same_family_account", id: "sameAccount" }
];

const defaultTitle = "Add new contact";

export default {
  components: {
    CommonModal,
    FamilySelectComponent
  },
  props: ["name", "studentData"],
  inject: ["fetchStudentData"],
  created() {
    this.handleResize();
    window.addEventListener("resize", this.handleResize);
    this.fetchStudentOpts();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  data() {
    return {
      mode: "add",
      title: "student.add_new_contact",
      primaryAction: {
        title: "common.add",
        action: this.doSubmit
      },
      contact: defaultContact(),
      sameContact: defaultSameContact(),
      typeAddress: typeAddress(),
      validateContact: validations,
      validateFamily: {
        required: true,
        maxLength: 255
      },
      primaryAddress: null,
      secondaryAddress: null,
      serverValidations: {},
      typeAccount: typeAccount(),
      typeAccountSelected: "newAccount",
      roleSelect: {
        label: this.$t("subject.condition"),
        type: "select",
        options: [
          {
            id: "Student",
            name: this.$t("common.student")
          },
          {
            id: "Family",
            name: this.$t("common.family")
          }
        ]
      },
      studentSelect: {
        label: this.$t("class.student_filter_id_fullname"),
        name: "user_id",
        fields: {
          text: "displayName",
          value: "id"
        },
        options: [],
        searchKey: "search_key",
        refetchOptions: this.fetchStudentOpts
      },
      familiesSelect: {
        label: this.$t("student.label_filter_fullname_username"),
        value: [],
        type: "checkbox-multi-select",
        options: [],
        trackBy: "id",
        displayField: "name",
        searchKey: "search_key",
        refetchOptions: this.fetchAccountFamilyConditionFamily,
        showSelectAll: true
      },
      errorMessage: false,
      otherAddress: {
        country: {
          value: "",
          displayValue: "",
          fields: {
            text: "name",
            value: "two_code"
          },
          searchKey: "search_key"
        },
        state: {
          value: "",
          displayValue: "",
          fields: {
            text: "name",
            value: "name"
          },
          searchKey: "search_key"
        }
      },
      countryOptions: [],
      stateOptions: [],
      generateWidth: null
    };
  },

  watch: {
    "contact.username": function() {
      this.serverValidations.username && delete this.serverValidations.username;
    },

    "contact.email": function() {
      this.serverValidations.email && delete this.serverValidations.email;
    },

    "contact.phone_number": function() {
      this.serverValidations.phone_number &&
        delete this.serverValidations.phone_number;
    },

    "contact.first_name": function() {
      this.serverValidations.first_name &&
        delete this.serverValidations.first_name;
    },

    "contact.last_name": function() {
      this.serverValidations.last_name &&
        delete this.serverValidations.last_name;
    },
    "sameContact.roleId": function(roleSelected) {
      this.sameContact.accountFamily = [];
      this.sameContact.studentId = null;
      this.sameContact.studentName = "";
      if (roleSelected === "Family") {
        this.fetchAccountFamilyConditionFamily();
      }
    },
    "sameContact.studentId": function(studentId) {
      if (studentId) {
        this.sameContact.accountFamily = [];
        this.sameContact.accountFamilySelected.family_ids = [];
        this.getAccountFamilyByStudent(studentId);
      }
    },
    "sameContact.familyId": function(familyIds) {
      if (familyIds?.length > 2) {
        this.errorMessage = true;
      } else {
        this.errorMessage = false;
        this.sameContact.accountFamilySelected.family_ids = familyIds;
      }
    },
    "otherAddress.country.displayValue"(newCountry) {
      if (!newCountry) {
        this.otherAddress.state.displayValue = "";
        this.otherAddress.state.value = "";
      }
      this.contact.form_account_address.country = newCountry;
    },

    "otherAddress.state.displayValue"(newState) {
      this.contact.form_account_address.state = newState;
    }
  },

  computed: {
    isFamilyRole() {
      return hasValidRole(this.userRole, [Role.Family]);
    },
    isDisableChangeAddress() {
      return this.contact.type_account_address !== "other";
    },
    studentId() {
      return this.$route.params.id;
    },

    isEditPage() {
      return this.mode === "edit";
    },
    ...mapGetters("user", { userRole: "role" })
  },

  methods: {
    getCountries(selectedValue, searchKey) {
      return this.$axios
        .get(
          `${service_names.user}/countries`,
          {
            "name__~": searchKey
          },
          undefined,
          undefined,
          undefined,
          undefined,
          false
        )
        .then(({ data }) => {
          this.countryOptions = data.data;
        });
    },
    getStates(countryCode, searchKey) {
      return this.$axios
        .get(
          `${service_names.user}/states`,
          {
            country_code: countryCode,
            "name__~": searchKey
          },
          undefined,
          undefined,
          undefined,
          undefined,
          false
        )
        .then(({ data }) => {
          this.stateOptions = data.data;
        });
    },
    changeAddressOption(name) {
      if (name === "other") {
        this.contact.form_account_address = defaultContact().form_account_address;
      } else if (name === "secondary_address") {
        this.contact.form_account_address = this.secondaryAddress;
      } else {
        this.contact.form_account_address = this.primaryAddress;
      }
    },
    doSubmit() {
      this.$refs.addFamily.submitForm();
    },
    handleResize() {
      this.generateWidth = window.innerWidth < 959 ? "100%" : "800px";
    },
    saveForm() {
      if (this.mode === "add") {
        this.typeAccountSelected === "newAccount"
          ? this.addNewContact()
          : this.addSameAccount();
      }
      if (this.mode === "edit") {
        this.editContact();
      }
    },
    fetchStudentOpts(params) {
      params = { ...params, fields: ["full_name", "student_code"], limit: 20 };
      this.$axios
        .get(
          `${service_paths.students}/filter`,
          params,
          undefined,
          undefined,
          undefined,
          undefined,
          false
        )
        .then(response => {
          let options = [];
          response.data.data.map(student => {
            if (getId(student) !== this.studentId) {
              options.push({
                id: getId(student),
                displayName: student.student_code
                  ? `${student.full_name} - ${student.student_code}`
                  : student.full_name
              });
            }
          });
          this.studentSelect.options = options;
        });
    },
    async getAccountFamilyByStudent(studentId) {
      await this.$axios
        .get(
          `${service_paths.families}/students/${studentId}`,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          false
        )
        .then(response => {
          response.data.map(family => {
            const userSql = family.parent?.user_no_sql;
            if (userSql) {
              this.sameContact.accountFamily.push({
                id: getId(userSql),
                text: `${userSql.full_name} - ${userSql.username} - ${userSql.email}`
              });
            }
          });
        });
    },
    fetchAccountFamilyConditionFamily(
      queryObj,
      params = {
        search_key: queryObj,
        fields: ["full_name", "username"],
        limit: 100
      }
    ) {
      return this.$axios
        .get(
          service_paths.families + `/filter`,
          params,
          undefined,
          undefined,
          undefined,
          undefined,
          false
        )
        .then(({ data: resData }) => {
          this.familiesSelect.options = resData.data;
        });
    },
    addSameAccount() {
      this.$axios
        .post(
          `${service_paths.families}/duplicate/student/${this.studentId}`,
          this.sameContact.accountFamilySelected
        )
        .then(() => {
          this.$modal.hide(this.name);
          this.fetchStudentData();
          Message.success(
            this.$t("student.add_new_family_contact_successfully")
          );
        })
        .catch(error => {
          const svErrMsgs = errData.messages;
          this.serverValidations = genErrMsgOj(svErrMsgs);
        });
    },
    addNewContact() {
      this.contact.children_id = this.studentId;
      this.$axios
        .post(`${service_paths.families}`, this.contact)
        .then(() => {
          this.$modal.hide(this.name);
          this.fetchStudentData();
          Message.success(
            this.$t("student.add_new_family_contact_successfully")
          );
        })
        .catch(error => {
          const errData = error.response?.data;
          if (errData) {
            const svErrMsgs = errData.messages;
            this.serverValidations = genErrMsgOj(svErrMsgs);
          }
        });
    },

    editContact() {
      this.$axios
        .put(`${service_paths.families}/${this.contact._id}`, this.contact)
        .then(() => {
          this.$modal.hide(this.name);
          this.fetchStudentData();
          Message.success(this.$t("student.update_contact_successfully"));
        })
        .catch(error => {
          const errData = error.response?.data;

          if (errData) {
            const svErrMsgs = errData.messages;
            this.serverValidations = genErrMsgOj(svErrMsgs);
          }
        });
    },

    show(data) {
      this.mode = data.mode;
      this.setContactAddress(this.studentData);
      if (data.mode === "add") {
        this.contact.form_account_address = this.primaryAddress;
        this.$modal.show(this.name);
        return;
      }

      if (data.mode === "edit") {
        this.title = this.$t("student.edit_family_contact");
        this.contact = Object.assign({}, this.contact, cloneDeep(data.contact));
        this.setOtherAddress();
        this.primaryAction.title = "Save";
        this.primaryAction.action = this.doSubmit;
        this.$modal.show(this.name);
      }
    },
    setContactAddress(studentData) {
      this.primaryAddress = {
        street: studentData.primary_street,
        apartment: studentData.primary_apartment,
        state: studentData.primary_state,
        city: studentData.primary_city,
        zip: studentData.primary_zip,
        country: studentData.primary_country
      };
      this.secondaryAddress = {
        street: studentData.secondary_street,
        apartment: studentData.secondary_apartment,
        state: studentData.secondary_state,
        city: studentData.secondary_city,
        zip: studentData.secondary_zip,
        country: studentData.secondary_country
      };
    },
    setOtherAddress() {
      if (this.contact.type_account_address === "other") {
        this.$axios
          .get(`${service_names.user}/countries`, {
            "name__~": this.contact.form_account_address.country
          })
          .then(({ data }) => {
            this.otherAddress.country.displayValue = data?.data[0].name;
            this.otherAddress.country.value = data?.data[0].two_code;
          });
        this.otherAddress.state.displayValue = this.contact.form_account_address.state;
        this.otherAddress.state.value = this.contact.form_account_address.state;
      }
    },
    clearModalData() {
      this.typeAccountSelected = "newAccount";
      this.title = defaultTitle;
      this.sameContact = defaultSameContact();
      this.contact = defaultContact();
      this.primaryAction = {
        title: "Add",
        action: this.doSubmit
      };
    },

    getValidationClass(fieldName) {
      return {
        "md-invalid": !!this.serverValidations[fieldName]
      };
    },

    styleErrorServer(fieldName) {
      return {
        "mb-40": !!this.serverValidations[fieldName]
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.mb-40 {
  margin-bottom: 40px !important;
}
.md-error {
  top: 40px;
}
::v-deep .checkbox-multi-selections label {
  display: block;
  margin: -3px 0;
  color: #aaa;
  font-weight: 400;
}
</style>
